import React from 'react'
import classnames from 'classnames'

const renderInputField = ({ className, input, label, placeholder, type, meta: { touched, error } }) => (
  <div className={classnames('form__form-group-input-wrap', className)}>
    <input {...input} placeholder={placeholder} type={type} className={classnames({error: touched && error})} />
    {touched && error && <span className='form__form-group-error'>{error}</span>}
  </div>
);

export default renderInputField;


// WEBPACK FOOTER //
// ./src/components/formFields/Input.js